import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../components/Grid'
import StripePageTitle from '../components/StripePageTitle'
import StripeTabs from '../components/StripeTabs'
import StripeActiveFilters from '../components/StripeActiveFilters'
import UbliqueContainer from '../components/Container'
import { noop } from 'lodash'

import './index.scss'

const PageOutputTabs = ({
  title,
  className,
  stripeMultiTabs,
  stripeModal,
  stripeActiveFilters,
  configMenu
}) => {
  return (
    <UbliqueContainer stripeModal={stripeModal}>
      <Grid className={cn('ublique-page-multi-tabs', className)}>
        {title && <StripePageTitle text={title} configMenu={configMenu} />}
        {stripeActiveFilters && (
          <StripeActiveFilters filterProps={stripeActiveFilters} />
        )}
        {stripeMultiTabs.map(({ stripeTabs, onTabChange = noop }, idx) => (
          <StripeTabs
            key={`stripe-multi-tab-${idx}`}
            tabs={stripeTabs}
            onTabChange={onTabChange}
          />
        ))}
      </Grid>
    </UbliqueContainer>
  )
}

PageOutputTabs.propTypes = {
  // da sistemare con Yup
  title: PropTypes.string,
  className: PropTypes.string,
  stripeMultiTabs: PropTypes.array.isRequired,
  stripeModal: PropTypes.object,
  stripeActiveFilters: PropTypes.object,
  configMenu: PropTypes.object
}

export default PageOutputTabs
